import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

const AskDialog = ({
  visible,
  title,
  description,
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
  onCancle,
  showCancel = true,
}) => {
  return (
    <Dialog
      open={visible}
      onClose={onCancle}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="subtitle2" component="div">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography
          sx={{ whiteSpace: 'pre-line' }}
          variant="body2"
          component="div"
        >
          {description}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: showCancel ? 'space-between' : 'flex-end',
          alignItems: 'center',
        }}
      >
        {showCancel && (
          <Button variant="outlined" onClick={onCancle} autoFocus>
            {cancelText}
          </Button>
        )}
        <Button variant="outlined" color="error" onClick={onConfirm}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AskDialog;
